export default "__VITE_ASSET__e05938b9__"